import React from "react";
import { InputLabel, FormControl, FormHelperText } from "@mui/material";
import GlobalDropdown from "./GlobalDropDown";

const GlobalDropdownField = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder = "Select",
  options = [],
  error = false,
  errorMessage = "", // ✅ Updated from errorText
  required = false,
  variant,
  renderValueFn,
  renderMenuItem,
  menuProps = {},
  multiple = false,
  search, // ✅ Added search prop
  disabled = false,
  counts = {},
  useNewStyles = false,
  height,
  onClose,
}) => {
  return (
    <>
      {label &&
        (variant === "enquirySelect" ? (
          <label
            className={`text-[12px] font-[500] ${
              error ? "text-[var(--error-color)]" : "text-[var(--label-color)]"
            }`}
            style={{ display: "block" }}
          >
            {label} {required && "*"}
          </label>
        ) : (
          <InputLabel
            style={{
              display: "block",
              fontSize: "16px",
              fontWeight: "normal",
              color: error ? "var(--error-color)" : "var(--label-color)",
            }}
          >
            {label} {required && "*"}
          </InputLabel>
        ))}

      {label ? (
        <FormControl fullWidth size="small" sx={{ mt: 1 }} disabled={disabled}>
          <GlobalDropdown
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            options={options}
            variant={variant}
            renderValueFn={renderValueFn}
            renderMenuItem={renderMenuItem}
            menuProps={menuProps}
            multiple={multiple}
            counts={counts}
            search={search}
            error={error}
            disabled={disabled}
            useNewStyles={useNewStyles}
            height={height}
            onClose={onClose}
          />
          {error && (
            <span className="text-[12px] text-[var(--error-color)] ml-4 mt-1">
              {errorMessage || `Please select ${label}`}
            </span>
          )}
        </FormControl>
      ) : (
        <>
          <GlobalDropdown
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            options={options}
            variant={variant}
            renderValueFn={renderValueFn}
            renderMenuItem={renderMenuItem}
            menuProps={menuProps}
            multiple={multiple}
            counts={counts}
            errorMessage={errorMessage}
            search={search}
            error={error}
            disabled={disabled}
            useNewStyles={useNewStyles}
            height={height}
            onClose={onClose}
          />
          {error && (
            <span className="text-[11px] text-[var(--error-color)] ml-1 mt-1 block">
              {errorMessage || "Please select a value"}
            </span>
          )}
        </>
      )}
    </>
  );
};

export default GlobalDropdownField;
